<template>
    <div>
        <section>
            <h2>Page Not Found</h2>
            <p>This page could not be found - please check our coaches page <router-link to="/coaches">coaches</router-link></p>
        </section>
    </div>
</template>